/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ContactNotificationBehaviour {
    Allowing = '0',
    Blocking = -1,
}
